module.exports = new __parcel__URL__("confluence-pages.bd4cb8cc.svg").toString();